export default __webpack_public_path__ + "BetConstruct-Icons-60095b6a.eot";